import type { IcIcon } from "./types";

export const IcCloseBold: IcIcon = (properties) => (
  <svg
    fill="currentColor"
    height="18"
    viewBox="0 0 16 18"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
    {...properties}
  >
    <path d="M4.615 9 0 4.058 3.08.76l4.61 4.944L12.303.761l3.077 3.3L10.765 9l4.615 4.942-3.08 3.297-4.61-4.944-4.613 4.944L0 13.94 4.615 9Z" />
  </svg>
);
